import { render, staticRenderFns } from "./SectionPanel.vue?vue&type=template&id=4f6474cc&"
import script from "./SectionPanel.vue?vue&type=script&lang=js&"
export * from "./SectionPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports